import get from 'lodash/get'

export const isConfirmationDialogOpen = (state) => get(state, ['ui', 'confirmationDialog', 'open'])
export const getConfirmationTitle = (state) => get(state, ['ui', 'confirmationDialog', 'title'])
export const getConfirmationMessage = (state) => get(state, ['ui', 'confirmationDialog', 'message'])
export const getConfirmationPositiveAction = (state) => get(state, ['ui', 'confirmationDialog', 'positiveAction'])
export const getConfirmationNegativeAction = (state) => get(state, ['ui', 'confirmationDialog', 'negativeAction'])



// WEBPACK FOOTER //
// ./src/selectors/confirmationDialog.js